import { useAtom } from 'jotai'
import {
  useEntityFiltersBar,
  ActiveFilterPill,
  GreyGrey30,
  Flex
} from '@sequencehq/core-components'
import {
  watchtowerFiltersAtom,
  WatchtowerFilterType
} from 'Automations/watchtower/atoms'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { ALL_TASKS_FILTER_CONFIGS } from '../allTasksFilterConfigs'

export const FilterPills = () => {
  const flags = useFeatureFlags()
  const filters = ALL_TASKS_FILTER_CONFIGS({
    useAutomationsDunning: flags.useAutomationsDunning
  })
  const [selectedFilters, setSelectedFilters] = useAtom(watchtowerFiltersAtom)
  const { activeFilterPills, updateFilter, clearFilter } =
    useEntityFiltersBar<WatchtowerFilterType>({
      filters,
      selectedFilters,
      onFilterChange: setSelectedFilters
    })

  if (activeFilterPills.length === 0) return null

  return (
    <Flex
      gap="8px"
      alignItems="start"
      flexWrap="wrap"
      padding="8px 16px"
      borderBottom={`1px solid ${GreyGrey30}`}
    >
      {activeFilterPills.map(pill => (
        <ActiveFilterPill
          key={pill.filterType}
          {...pill}
          onChange={ids => updateFilter(pill.filterType, ids)}
          onClear={() => clearFilter(pill.filterType)}
        />
      ))}
    </Flex>
  )
}
